import { fileKeyEndpoints } from '@/api/endpoints';
import { FileKeyRegenerationService } from '@/services/abstract/FileKeyRegenerationService';
import type { FetcherService } from '@/services/abstract/FetcherService';
import type {
  FinalizeKeyRotationPayload,
  UploadRotatedFileKeysPayload,
  UserFileKeyRef,
} from '@/types/fileKey/FileKeyRegeneration';

export class FileKeyRegenerationServiceImpl extends FileKeyRegenerationService {
  constructor(private readonly fetcher: FetcherService) {
    super();
  }

  async getUserFileKeys(): Promise<UserFileKeyRef[]> {
    return await this.fetcher.get<UserFileKeyRef[]>(fileKeyEndpoints.getUserFileKeys);
  }

  /**
   * Hands the tar CID to HAP. The fetcher transparently polls the returned
   * command — that poll IS the completion signal. Polling failures still
   * reject; the global polling modal is suppressed because the change-password
   * flow surfaces its own inline error.
   */
  async uploadRotatedFileKeys(payload: UploadRotatedFileKeysPayload): Promise<void> {
    await this.fetcher.post(fileKeyEndpoints.uploadRotatedFileKeys, payload, {
      suppressPollingErrors: true,
    });
  }

  /** Commits the rotation; like the upload, the fetcher polls the command to completion. */
  async finalizeKeyRotation(payload: FinalizeKeyRotationPayload): Promise<void> {
    await this.fetcher.post(fileKeyEndpoints.finalizeKeyRotation, payload, {
      suppressPollingErrors: true,
    });
  }
}
